import { useEffect, useRef } from 'react';

export const useIntersectionObserver = ({ callback, rootMargin = '0px', threshold = 0 }) => {
  const observer = useRef();
  const root = useRef();
  const target = useRef();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }

    if (target.current) {
      observer.current = new IntersectionObserver(callback, { root: root.current, rootMargin, threshold });

      observer.current.observe(target.current);

      return () => {
        observer.current.disconnect();
      };
    }
  }, [root.current, target.current]);

  return [root, target];
};
